module.exports = __webpack_public_path__ + "img/tiinamaritakaneva2.583ab740.png";